(function () {

  if (window.HolkieBulkPricing && window.HolkieBulkPricing.initialized) return;



  window.HolkieBulkPricing = { initialized: true };



  function parseJsonDeep(value) {

    var parsed = value;



    for (var index = 0; index < 5; index += 1) {

      if (parsed == null || parsed === "") return null;

      if (typeof parsed !== "string") return parsed;



      try {

        parsed = JSON.parse(parsed);

      } catch (error) {

        return null;

      }

    }



    return parsed;

  }



  function normalizeTiers(value) {

    var source = parseJsonDeep(value);



    if (source && typeof source.value !== "undefined") {

      source = parseJsonDeep(source.value);

    }



    var tiers = [];



    if (Array.isArray(source)) {

      tiers = source;

    } else if (source && Array.isArray(source.tiers)) {

      tiers = source.tiers;

    }



    return tiers

      .map(function (tier) {

        return {

          min: Number(tier.min),

          max: tier.max === null || tier.max === "" || typeof tier.max === "undefined" ? null : Number(tier.max),

          discount: Number(tier.discount)

        };

      })

      .filter(function (tier) {

        return Number.isFinite(tier.min) && Number.isFinite(tier.discount);

      })

      .sort(function (a, b) {

        return a.min - b.min;

      });

  }



  function getBoxTiers(box) {

    var jsonScript = box.querySelector("[data-bulk-pricing-json]");

    var jsonText = jsonScript ? jsonScript.textContent.trim() : "";

    return normalizeTiers(jsonText || box.getAttribute("data-bulk-pricing") || window.bulkPricing);

  }



  function getCurrencyCode() {

    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {

      return window.Shopify.currency.active;

    }



    return window.currentCurrency || "USD";

  }



  function formatMoney(cents) {

    var amount = Number(cents) / 100;



    try {

      return new Intl.NumberFormat(undefined, {

        style: "currency",

        currency: getCurrencyCode(),

        minimumFractionDigits: 2,

        maximumFractionDigits: 2

      }).format(amount);

    } catch (error) {

      return (window.currencySymbol || "$") + amount.toFixed(2);

    }

  }



  function getQuantity(input) {

    var quantity = Number.parseInt(input && input.value, 10);

    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;

  }



  function getActiveTier(tiers, quantity) {

    return tiers.find(function (tier) {

      return quantity >= tier.min && (tier.max === null || quantity <= tier.max);

    }) || tiers[0];

  }



  function getNextTier(tiers, quantity) {

    return tiers.find(function (tier) {

      return quantity < tier.min;

    });

  }



  function getUnitPriceCents(box) {

    var price = Number(box.dataset.currentPriceCents || box.dataset.initialPriceCents || 0);

    return Number.isFinite(price) ? price : 0;

  }



  function calculateDiscountedTotal(unitPriceCents, quantity, discountPercent) {
    var discount = Number(discountPercent) || 0;

    if (!discount) return unitPriceCents * quantity;

    // Shopify rounds the discounted unit price before multiplying by quantity.
    var discountedUnitPrice = Math.ceil((unitPriceCents * (100 - discount)) / 100);
    return discountedUnitPrice * quantity;
  }


  function renderTiers(box, tiers, activeTier) {

    var list = box.querySelector("[data-tiers-list]");

    if (!list) return;



    list.innerHTML = tiers

      .filter(function (tier) {

        return !(tier.min === 1 && tier.discount === 0);

      })

      .map(function (tier) {

        var range = tier.max === null ? tier.min + "+" : tier.min + "-" + tier.max;

        var isActive = activeTier && tier.min === activeTier.min && tier.max === activeTier.max;



        return [

          '<div class="tier-item' + (isActive ? " active" : "") + '">',

          '<span class="tier-qty">Buy ' + range + "</span>",

          '<span class="tier-discount">' + tier.discount + "% off</span>",

          "</div>"

        ].join("");

      })

      .join("");

  }



  function updateMailto(box, quantity) {

    var productTitle = box.dataset.productTitle || document.title;

    var subject = "Factory Pricing Request - " + productTitle;

    var body = [

      "Hello Holkie Team,",

      "",

      "I would like a quotation for:",

      "",

      "Product: " + productTitle,

      "Quantity: " + quantity,

      "",

      "Please provide:",

      "",

      "- Bulk pricing",

      "- Shipping cost",

      "- Lead time",

      "",

      "Thank you."

    ].join("\n");



    box.querySelectorAll("[data-bulk-mailto]").forEach(function (button) {

      button.href = "mailto:order@holkie.com?subject=" + encodeURIComponent(subject) + "&body=" + encodeURIComponent(body);

    });

  }



  function updateBox(box) {

    var form = box.closest("form");

    var quantityInput = form ? form.querySelector('input[name="quantity"]') : document.querySelector('input[name="quantity"]');

    var tiers = box.holkieBulkPricingTiers || [];

    var quantity = getQuantity(quantityInput);

    var unitPriceCents = getUnitPriceCents(box);

    var activeTier = getActiveTier(tiers, quantity);



    if (!tiers.length || !activeTier || !unitPriceCents) return;



    var nextTier = getNextTier(tiers, quantity);

    var baseTotalCents = unitPriceCents * quantity;

    var totalCents = calculateDiscountedTotal(unitPriceCents, quantity, activeTier.discount);

    var saveCents = baseTotalCents - totalCents;

    var originalTotal = box.querySelector("[data-original-total]");

    var save = box.querySelector("[data-save]");

    var total = box.querySelector("[data-total]");

    var nextContainer = box.querySelector("[data-next-container]");

    var quoteContainer = box.querySelector("[data-quote-container]");



    if (originalTotal) originalTotal.textContent = formatMoney(baseTotalCents);

    if (save) save.textContent = formatMoney(saveCents);

    if (total) total.textContent = formatMoney(totalCents);



    if (nextTier) {

      var nextQty = box.querySelector("[data-next-qty]");

      var nextDiscount = box.querySelector("[data-next-discount]");



      if (nextQty) nextQty.textContent = Math.max(nextTier.min - quantity, 0);

      if (nextDiscount) nextDiscount.textContent = nextTier.discount + "% off";

      if (nextContainer) nextContainer.hidden = false;

      if (quoteContainer) quoteContainer.hidden = true;

    } else {

      if (nextContainer) nextContainer.hidden = true;

      if (quoteContainer) quoteContainer.hidden = false;

    }



    renderTiers(box, tiers, activeTier);

    updateMailto(box, quantity);

  }



  function scheduleUpdate(box) {
    updateBox(box);


    window.setTimeout(function () {

      updateBox(box);

    }, 100);



    window.setTimeout(function () {

      updateBox(box);

    }, 400);



    window.setTimeout(function () {

      updateBox(box);

    }, 900);
  }

  function resetQuantity(box) {
    var form = box.closest("form");
    var quantityInput = form ? form.querySelector('input[name="quantity"]') : document.querySelector('input[name="quantity"]');

    if (!quantityInput) return;

    quantityInput.value = quantityInput.defaultValue || quantityInput.getAttribute("data-min") || "1";
  }


  function syncVariantPrice(box, variant) {

    if (!variant || variant.price === null || typeof variant.price === "undefined") return;

    box.dataset.currentPriceCents = String(Number(variant.price));

  }



  function bindVariantChange(box) {

    var form = box.closest("form");



    if (form) {

      form.addEventListener("variant:change", function (event) {

        syncVariantPrice(box, event.detail && event.detail.variant);

        updateBox(box);

      });

    }



    document.addEventListener("variant:change", function (event) {

      syncVariantPrice(box, event.detail && event.detail.variant);

      updateBox(box);

    });

  }



  function bindQuantityChange(box) {

    var form = box.closest("form");

    var quantityInput = form ? form.querySelector('input[name="quantity"]') : document.querySelector('input[name="quantity"]');



    if (quantityInput) {

      quantityInput.addEventListener("input", function () {

        updateBox(box);

      });



      quantityInput.addEventListener("change", function () {

        updateBox(box);

      });

    }



    if (form) {

      form.addEventListener("submit", function () {

        scheduleUpdate(box);

      });

    }

  }



  function bindCartChange(box) {
    document.addEventListener("ajaxProduct:added", function () {
      resetQuantity(box);
      scheduleUpdate(box);
    });


    if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS && typeof theme.pubsub.subscribe === "function") {

      theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && (event.source === "product-form" || event.source === "product-bundle")) {
          resetQuantity(box);
        }

        if (!event || !event.source || event.source === "product-form") {
          scheduleUpdate(box);
        }
      });

    }

  }



  function initBox(box) {

    var tiers = getBoxTiers(box);



    if (!tiers.length) {

      box.hidden = true;

      return;

    }



    box.holkieBulkPricingTiers = tiers;

    box.dataset.currentPriceCents = box.dataset.initialPriceCents || "0";



    bindQuantityChange(box);

    bindCartChange(box);

    bindVariantChange(box);

    updateBox(box);

  }



  function init() {

    document.querySelectorAll("[data-bulk-box]").forEach(initBox);

  }



  if (document.readyState === "loading") {

    document.addEventListener("DOMContentLoaded", init, { once: true });

  } else {

    init();

  }

})();